module.exports = __webpack_public_path__ + "img/logo-um-feri-ang.ad8b7c69.png";